module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-5418c669f2f274c7ebe8ee9fb23aa3a7.png";